<template>
  <div class="setting_pop_cell_contents_wrap">
    <div class="input-block">
      <div class="divide">
        <div class="first">Component ID</div>
        <div class="second">{{ items[0].value }}</div>
      </div>
      <div class="divide">
        <div class="first">차트 유형</div>
        <div class="second">
          <select v-model="chartType" @change="chgType">
            <option value="">선택해 주세요.</option>
            <option value="bar">Bar</option>
            <option value="line">Line</option>
            <option value="pie">Pie</option>
          </select>
        </div>
      </div>
      <div class="divide" v-if="dataSetData">
        <div class="first">Dataset</div>
        <div class="second">
          <select v-model="chartData" @change="chgData">
            <option value="null" selected>선택해 주세요.</option>
            <option
              v-for="(item, index) in dataSetData?.chart"
              :key="index"
              :value="item.format"
            >
              {{ item.title }}
            </option>
          </select>
        </div>
      </div>
      <div class="divide" v-if="dataSetData && filterDataList.length > 0">
        <div class="first">Filter type</div>
        <div class="second">
          <select v-model="filterType" @change="filterSettingTitle2($event)">
            <option value="">선택해 주세요.</option>
            <option
              v-for="item in filterDataList"
              :key="item.index"
              :value="item.index"
            >
              Filter {{ item.index }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div id="lodingWrap" style="display: none" ref="lodingWrap">
    <div class="loading-container">
      <div class="loding-animation-holder">
        <div class="loading-animator"></div>
        <div class="loading-animator"></div>
        <div class="loading-animator"></div>
        <div class="loading-animator"></div>
        <div class="middle-circle"></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "ChartControllerSetting",
  props: {
    otherProp: {
      type: Object,
      required: true, // 전달받는 값이 반드시 있어야 한다면 required를 true로 설정
    },
    nowIndex: {
      type: Number,
      required: true,
    },
    handlerList: {
      //handler
      type: Object,
      required: true,
    },
    dataSet: {
      type: Object,
    },
    layout: {
      type: Object,
    },
    filterDataList: {
      type: Object,
    },
  },
  data() {
    return {
      isShow: false,
      tempSelected: "",
      items: [
        { label: "Component ID", value: "" },
        { label: "Display Title", value: "" },
        { label: "Controller 추가", value: {} },
      ],
      nowindex: 0,
      componentType: "",
      components: [],
      layoutComponent: {},
      chartKind: "",
      dataSetData: null,

      handlerKey: "",
      dataLayout: null,
      chartData: null,
      chartType: "",
    };
  },
  async mounted() {
    const vm = this;
    const prop = this.otherProp;
    this.layoutComponent = _.cloneDeep(this.otherProp);
    this.$refs.lodingWrap.style.display = "block";
    this.dataSetData = this.dataSet;
    this.dataLayout = this.layout;

    console.log("this.dataLayout :: ", this.dataSetData);
    this.layoutComponent = _.cloneDeep(this.otherProp);
    this.components = _.cloneDeep(this.layoutComponent.components);

    if (this.components[this.nowindex]?.displayTitle != undefined) {
      this.displayTitle = this.components[this.nowindex]?.displayTitle;
    } else {
      this.displayTitle = "";
    }
    const components_cp = this.components;
    for (let i = 0; i < components_cp.length; i++) {
      let valueStart = components_cp[i].valueStart;
      let valueEnd = components_cp[i].valueEnd;
      if (valueStart !== null) {
        if (typeof valueStart === "string") {
          valueStart = new Date(valueStart);
        }
      }
      if (valueEnd !== null) {
        if (typeof valueEnd === "string") {
          valueEnd = new Date(valueEnd);
        }
      }
    }

    this.components = _.cloneDeep(components_cp);
    this.items[0].value = this.layoutComponent.key;
    this.items[1].value = this.layoutComponent.type;
    const type = this.componentType;
    const handlerCount = String(this.handlerList.length + 1).padStart(3, "0");
    const component = {
      type: type,
      labelText: "",
      value: "",
      valueStart: "",
      valueEnd: "",
      key: this.components.length + 1 + "-" + Math.floor(Date.now()),
      handlerKey: "Handler" + handlerCount,
      remove: false,
      child: {},
      parentHandlerKey: "",
      controlHandlerLabelText: "",
      keyValueList: [],
      keyValueType: "",
      parameter: "",
      range: {
        startRange: 0,
        endRange: 0,
        step: 0,
      },
    };
    this.components.push(component);
    this.component = component;
    this.$emit("updateHandler", component);
    this.component = _.cloneDeep(this.component);
    this.$refs.lodingWrap.style.display = "none";
    if (prop.filterType !== "") {
      vm.filterType = prop.filterType != undefined ? prop.filterType : "";
    }
    this.dataSetData = this.dataSet;
  },
  methods: {
    chgType() {
      this.components[0].chartType = this.chartType;
      this.components = _.cloneDeep(this.components);
    },
    chgData() {
      this.components[0].chartData = this.chartData;
      this.components = _.cloneDeep(this.components);
    },
    updateParent({ index, value }) {
      this.components[index].parentHandlerKey = value;
      this.components = _.cloneDeep(this.components);
    },
    updateItem(index, newValue) {
      this.components.splice(index, 1, newValue); // 배열의 값 변경
    },
    removeItem(index) {
      this.$emit("removeHandler", this.components[index]);
      this.components.splice(index, 1); // 해당 인덱스의 객체를 배열에서 제거
    },
    filterSettingTitle2() {
      // const value = event.target.value;
      this.layoutComponent.filterType = this.filterType;
      this.layoutComponent = _.cloneDeep(this.layoutComponent);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.divide {
  min-height: 50px;
  margin: 0;
  &:first-child {
    .second {
      border-top: 1px solid #d5dae3;
    }
  }
  &:last-child {
    .first {
      border: 0;
    }
  }
  .first {
    width: 40%;
    background-color: #00b4ed;
    border-bottom: 1px solid #fff;
    color: #fff;
    font-weight: 600;
  }
  .second {
    border-right: 1px solid #d5dae3;
    border-bottom: 1px solid #d5dae3;
    &.upload {
      gap: 10px;
      label {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        padding: 0 12px;
        border-radius: 10px;
        color: #fff;
        background-color: #405261;
        box-sizing: border-box;
        cursor: pointer;
      }
      input[type="text"] {
        height: 40px;
        padding: 0 10px;
        border: 1px solid #d5dae3;
        border-radius: 10px;
        box-sizing: border-box;
      }
    }
  }
}
select {
  width: 150px;
  background-position: center right 15px;
}
</style>
